// App.js
import './App.css';

import React from 'react';
import Game from './Game';

const App = () => {
  return (
    <div className='App'>
      <Game />
    </div>
  );
};

export default App;
